export const WORK_MODELS = [
  {
    label: "On Site",
    value: "onsite",
  },
  {
    label: "Hybrid",
    value: "hybrid",
  },
  {
    label: "Remote",
    value: "remote",
  },
];

export const LEVEL_LIST = [
  { label: "Internship", value: "internship" },
  { label: "Entry Level", value: "entry_level" },
  { label: "Junior Level", value: "junior_level" },
  { label: "Mid Level", value: "mid_level" },
  { label: "Senior Level", value: "senior_level" },
];

export const COURSES = [
  { label: "Computer Science", value: "Computer Science" },
  { label: "Mechanical Engineering", value: "Mechanical Engineering" },
  { label: "Law", value: "Law" },
  { label: "Electrical Engineering", value: "Electrical Engineering" },
  { label: "Civil Engineering", value: "Civil Engineering" },
  { label: "Business Administration", value: "Business Administration" },
  { label: "Finance", value: "Finance" },
  { label: "Accounting", value: "Accounting" },
  { label: "Marketing", value: "Marketing" },
  { label: "Psychology", value: "Psychology" },
  { label: "Medicine", value: "Medicine" },
  { label: "Pharmacy", value: "Pharmacy" },
  { label: "Nursing", value: "Nursing" },
  { label: "Sociology", value: "Sociology" },
  { label: "Education", value: "Education" },
  { label: "Architecture", value: "Architecture" },
  { label: "Mechanical Design", value: "Mechanical Design" },
  { label: "Economics", value: "Economics" },
  { label: "Mathematics", value: "Mathematics" },
  { label: "Physics", value: "Physics" },
  { label: "Chemistry", value: "Chemistry" },
  { label: "Biology", value: "Biology" },
  { label: "Environmental Science", value: "Environmental Science" },
  { label: "Political Science", value: "Political Science" },
  { label: "Philosophy", value: "Philosophy" },
  { label: "Linguistics", value: "Linguistics" },
  { label: "History", value: "History" },
  { label: "Art History", value: "Art History" },
  { label: "Music", value: "Music" },
  { label: "Theater", value: "Theater" },
  { label: "Fine Arts", value: "Fine Arts" },
  { label: "Graphic Design", value: "Graphic Design" },
  { label: "Film Studies", value: "Film Studies" },
  { label: "Journalism", value: "Journalism" },
  { label: "Social Work", value: "Social Work" },
  { label: "Public Relations", value: "Public Relations" },
  { label: "International Relations", value: "International Relations" },
  { label: "Hospitality Management", value: "Hospitality Management" },
  { label: "Sports Management", value: "Sports Management" },
  { label: "Veterinary Science", value: "Veterinary Science" },
  { label: "Astronomy", value: "Astronomy" },
  { label: "Geography", value: "Geography" },
  { label: "Meteorology", value: "Meteorology" },
  { label: "Geology", value: "Geology" },
  { label: "Agricultural Science", value: "Agricultural Science" },
  { label: "Nutrition", value: "Nutrition" },
  { label: "Health Sciences", value: "Health Sciences" },
  { label: "Public Health", value: "Public Health" },
  { label: "Cybersecurity", value: "Cybersecurity" },
  { label: "Cloud Computing", value: "Cloud Computing" },
  { label: "Artificial Intelligence", value: "Artificial Intelligence" },
  { label: "Data Science", value: "Data Science" },
  { label: "Machine Learning", value: "Machine Learning" },
  { label: "Business Analytics", value: "Business Analytics" },
  { label: "Big Data", value: "Big Data" },
  { label: "Robotics", value: "Robotics" },
  { label: "Blockchain", value: "Blockchain" },
  { label: "Game Development", value: "Game Development" },
  { label: "Software Engineering", value: "Software Engineering" },
  { label: "Web Development", value: "Web Development" },
  { label: "Mobile Development", value: "Mobile Development" },
  { label: "DevOps", value: "DevOps" },
  { label: "Digital Marketing", value: "Digital Marketing" },
  { label: "Search Engine Optimization", value: "Search Engine Optimization" },
  { label: "E-Commerce", value: "E-Commerce" },
  { label: "Business Intelligence", value: "Business Intelligence" },
  { label: "Human Resources", value: "Human Resources" },
  { label: "Supply Chain Management", value: "Supply Chain Management" },
  { label: "Entrepreneurship", value: "Entrepreneurship" },
  { label: "Management", value: "Management" },
  { label: "Operations Management", value: "Operations Management" },
  { label: "Project Management", value: "Project Management" },
  { label: "Strategic Management", value: "Strategic Management" },
  { label: "Leadership", value: "Leadership" },
  { label: "Public Policy", value: "Public Policy" },
  { label: "Urban Planning", value: "Urban Planning" },
  { label: "Sustainability", value: "Sustainability" },
  { label: "Logistics", value: "Logistics" },
  { label: "Real Estate", value: "Real Estate" },
  { label: "Risk Management", value: "Risk Management" },
  { label: "Insurance", value: "Insurance" },
  { label: "Actuarial Science", value: "Actuarial Science" },
  { label: "Humanities", value: "Humanities" },
  { label: "Theology", value: "Theology" },
  { label: "Public Administration", value: "Public Administration" },
  { label: "Library Science", value: "Library Science" },
  { label: "Tourism", value: "Tourism" },
  { label: "Fashion Design", value: "Fashion Design" },
  { label: "Interior Design", value: "Interior Design" },
  { label: "Architecture Engineering", value: "Architecture Engineering" },
  { label: "Construction Management", value: "Construction Management" },
  { label: "Supply Chain Engineering", value: "Supply Chain Engineering" },
  { label: "Military Science", value: "Military Science" },
  { label: "Aerospace Engineering", value: "Aerospace Engineering" },
  { label: "Marine Engineering", value: "Marine Engineering" },
  { label: "Automotive Engineering", value: "Automotive Engineering" },
  { label: "Textile Engineering", value: "Textile Engineering" },
  { label: "Petroleum Engineering", value: "Petroleum Engineering" },
  { label: "Mining Engineering", value: "Mining Engineering" },
  { label: "Chemical Engineering", value: "Chemical Engineering" },
  { label: "Nuclear Engineering", value: "Nuclear Engineering" },
  { label: "Industrial Engineering", value: "Industrial Engineering" },
  { label: "Biomedical Engineering", value: "Biomedical Engineering" },
  { label: "Agricultural Engineering", value: "Agricultural Engineering" },
  { label: "Marine Science", value: "Marine Science" },
  { label: "Forensic Science", value: "Forensic Science" },
  { label: "Environmental Engineering", value: "Environmental Engineering" },
  { label: "Liberal Arts", value: "Liberal Arts" },
  { label: "Criminal Justice", value: "Criminal Justice" },
  {
    label: "Public Health Administration",
    value: "Public Health Administration",
  },
  { label: "Behavioral Science", value: "Behavioral Science" },
  { label: "Social Psychology", value: "Social Psychology" },
  { label: "Cognitive Science", value: "Cognitive Science" },
  { label: "Neuroscience", value: "Neuroscience" },
  { label: "Biotechnology", value: "Biotechnology" },
  { label: "Biochemistry", value: "Biochemistry" },
  { label: "Genetics", value: "Genetics" },
  { label: "Microbiology", value: "Microbiology" },
  { label: "Immunology", value: "Immunology" },
  { label: "Veterinary Medicine", value: "Veterinary Medicine" },
  { label: "Agronomy", value: "Agronomy" },
  { label: "Fisheries Science", value: "Fisheries Science" },
  { label: "Oceanography", value: "Oceanography" },
  { label: "Ethnic Studies", value: "Ethnic Studies" },
  { label: "Gender Studies", value: "Gender Studies" },
  { label: "Theatre Arts", value: "Theatre Arts" },
  { label: "Visual Arts", value: "Visual Arts" },
  { label: "Philosophy of Science", value: "Philosophy of Science" },
  { label: "Educational Psychology", value: "Educational Psychology" },
  { label: "Physical Education", value: "Physical Education" },
  { label: "Sports Science", value: "Sports Science" },
  { label: "Sports Medicine", value: "Sports Medicine" },
  {
    label: "Public Relations and Communication",
    value: "Public Relations and Communication",
  },
  {
    label: "Library and Information Science",
    value: "Library and Information Science",
  },
  { label: "Anthropology", value: "Anthropology" },
  { label: "Archaeology", value: "Archaeology" },
  { label: "Statistics", value: "Statistics" },
  { label: "Data Analytics", value: "Data Analytics" },
  { label: "Machine Vision", value: "Machine Vision" },
  { label: "Artificial Neural Networks", value: "Artificial Neural Networks" },
  { label: "Autonomous Systems", value: "Autonomous Systems" },
  { label: "Human-Computer Interaction", value: "Human-Computer Interaction" },
  { label: "Telecommunications", value: "Telecommunications" },
  { label: "Photography", value: "Photography" },
  { label: "Textile Technology", value: "Textile Technology" },
  { label: "Biochemical Engineering", value: "Biochemical Engineering" },
  { label: "Nanotechnology", value: "Nanotechnology" },
  { label: "Material Science", value: "Material Science" },
  { label: "Quantum Computing", value: "Quantum Computing" },
  { label: "Space Technology", value: "Space Technology" },
  { label: "Artificial Life", value: "Artificial Life" },
  { label: "Cyber-Physical Systems", value: "Cyber-Physical Systems" },
  { label: "Smart Manufacturing", value: "Smart Manufacturing" },
  {
    label: "Voice User Interface Design",
    value: "Voice User Interface Design",
  },
  { label: "Automated Systems", value: "Automated Systems" },
  { label: "Blockchain Development", value: "Blockchain Development" },
  { label: "Digital Media Design", value: "Digital Media Design" },
  { label: "Virtual Reality", value: "Virtual Reality" },
  { label: "Augmented Reality", value: "Augmented Reality" },
  { label: "Human-Robot Interaction", value: "Human-Robot Interaction" },
  { label: "Cloud Architecture", value: "Cloud Architecture" },
  { label: "Biomedical Informatics", value: "Biomedical Informatics" },
  { label: "Data Privacy", value: "Data Privacy" },
  { label: "Information Security", value: "Information Security" },
  {
    label: "Game Design and Development",
    value: "Game Design and Development",
  },
  { label: "Social Media Marketing", value: "Social Media Marketing" },
  { label: "Digital Film Production", value: "Digital Film Production" },
  { label: "Financial Engineering", value: "Financial Engineering" },
  { label: "Applied Mathematics", value: "Applied Mathematics" },
  { label: "Software Testing", value: "Software Testing" },
  { label: "Network Engineering", value: "Network Engineering" },
  { label: "User Experience Design", value: "User Experience Design" },
  { label: "Computer Graphics", value: "Computer Graphics" },
  { label: "Computational Biology", value: "Computational Biology" },
  { label: "Bioinformatics", value: "Bioinformatics" },
  { label: "Cloud Security", value: "Cloud Security" },
  { label: "AI Ethics", value: "AI Ethics" },
  { label: "Algorithm Design", value: "Algorithm Design" },
  { label: "Automation Engineering", value: "Automation Engineering" },
  { label: "IoT Engineering", value: "IoT Engineering" },
  { label: "Supply Chain Analytics", value: "Supply Chain Analytics" },
  { label: "Smart Cities", value: "Smart Cities" },
  { label: "Emerging Technologies", value: "Emerging Technologies" },
  { label: "Geospatial Sciences", value: "Geospatial Sciences" },
  { label: "Digital Healthcare", value: "Digital Healthcare" },
  { label: "AI in Healthcare", value: "AI in Healthcare" },
  { label: "Digital Law", value: "Digital Law" },
  { label: "Blockchain Law", value: "Blockchain Law" },
  { label: "Cyber Law", value: "Cyber Law" },
  { label: "E-Government", value: "E-Government" },
  {
    label: "Artificial Intelligence in Education",
    value: "Artificial Intelligence in Education",
  },
  { label: "Healthcare Management", value: "Healthcare Management" },
  { label: "Telemedicine", value: "Telemedicine" },
];

export const SKILLS = [
  { label: "Communication", value: "Communication" },
  { label: "Active Listening", value: "Active Listening" },
  { label: "Empathy", value: "Empathy" },
  { label: "Emotional Intelligence", value: "Emotional Intelligence" },
  { label: "Adaptability", value: "Adaptability" },
  { label: "Flexibility", value: "Flexibility" },
  { label: "Resilience", value: "Resilience" },
  { label: "Stress Management", value: "Stress Management" },
  { label: "Problem-Solving", value: "Problem-Solving" },
  { label: "Critical Thinking", value: "Critical Thinking" },
  { label: "Creativity", value: "Creativity" },
  { label: "Innovation", value: "Innovation" },
  { label: "Decision-Making", value: "Decision-Making" },
  { label: "Strategic Thinking", value: "Strategic Thinking" },
  { label: "Analytical Thinking", value: "Analytical Thinking" },
  { label: "Collaboration", value: "Collaboration" },
  { label: "Teamwork", value: "Teamwork" },
  { label: "Relationship Building", value: "Relationship Building" },
  { label: "Conflict Resolution", value: "Conflict Resolution" },
  { label: "Negotiation", value: "Negotiation" },
  { label: "Persuasion", value: "Persuasion" },
  { label: "Influencing", value: "Influencing" },
  { label: "Leadership", value: "Leadership" },
  { label: "Coaching", value: "Coaching" },
  { label: "Mentoring", value: "Mentoring" },
  { label: "Delegation", value: "Delegation" },
  { label: "Accountability", value: "Accountability" },
  { label: "Time Management", value: "Time Management" },
  { label: "Organization", value: "Organization" },
  { label: "Planning", value: "Planning" },
  { label: "Goal Setting", value: "Goal Setting" },
  { label: "Attention to Detail", value: "Attention to Detail" },
  { label: "Initiative", value: "Initiative" },
  { label: "Proactivity", value: "Proactivity" },
  { label: "Ownership", value: "Ownership" },
  { label: "Dependability", value: "Dependability" },
  { label: "Reliability", value: "Reliability" },
  { label: "Integrity", value: "Integrity" },
  { label: "Ethics", value: "Ethics" },
  { label: "Professionalism", value: "Professionalism" },
  { label: "Cultural Awareness", value: "Cultural Awareness" },
  { label: "Diversity & Inclusion", value: "Diversity & Inclusion" },
  { label: "Customer Focus", value: "Customer Focus" },
  { label: "Service Orientation", value: "Service Orientation" },
  { label: "Networking", value: "Networking" },
  { label: "Presentation Skills", value: "Presentation Skills" },
  { label: "Public Speaking", value: "Public Speaking" },
  { label: "Written Communication", value: "Written Communication" },
  { label: "Verbal Communication", value: "Verbal Communication" },
  { label: "Diplomacy", value: "Diplomacy" },
  { label: "Open-mindedness", value: "Open-mindedness" },
  { label: "Curiosity", value: "Curiosity" },
  { label: "Learning Agility", value: "Learning Agility" },
  { label: "Self-Motivation", value: "Self-Motivation" },
  { label: "Self-Awareness", value: "Self-Awareness" },
  { label: "Self-Confidence", value: "Self-Confidence" },
  { label: "Stress Tolerance", value: "Stress Tolerance" },
  { label: "Perseverance", value: "Perseverance" },
  { label: "Adaptability to Change", value: "Adaptability to Change" },
  { label: "Facilitation", value: "Facilitation" },
  { label: "Mediation", value: "Mediation" },
  { label: "Mindfulness", value: "Mindfulness" },
  { label: "Ethical Judgment", value: "Ethical Judgment" },
  { label: "Risk Awareness", value: "Risk Awareness" },
  { label: "Initiative Taking", value: "Initiative Taking" },
  { label: "Resourcefulness", value: "Resourcefulness" },
  { label: "Work Ethic", value: "Work Ethic" },
  { label: "Positive Attitude", value: "Positive Attitude" },
  { label: "Trustworthiness", value: "Trustworthiness" },
  { label: "Emotional Regulation", value: "Emotional Regulation" },
  { label: "Visioning", value: "Visioning" },
  { label: "Systems Thinking", value: "Systems Thinking" },
  { label: "Conflict Management", value: "Conflict Management" },
  { label: "Motivational Skills", value: "Motivational Skills" },
  {
    label: "Cross-Functional Collaboration",
    value: "Cross-Functional Collaboration",
  },
  { label: "Stakeholder Management", value: "Stakeholder Management" },
  { label: "Interpersonal Skills", value: "Interpersonal Skills" },
  { label: "Collaborative Leadership", value: "Collaborative Leadership" },
  { label: "Change Management", value: "Change Management" },
  { label: "Facilitation Skills", value: "Facilitation Skills" },
  { label: "Growth Mindset", value: "Growth Mindset" },
  { label: "Python", value: "Python" },
  { label: "Java", value: "Java" },
  { label: "C#", value: "C#" },
  { label: "JavaScript", value: "JavaScript" },
  { label: "TypeScript", value: "TypeScript" },
  { label: "Go", value: "Go" },
  { label: "Ruby", value: "Ruby" },
  { label: "PHP", value: "PHP" },
  { label: "Swift", value: "Swift" },
  { label: "Kotlin", value: "Kotlin" },
  { label: "SQL", value: "SQL" },
  { label: "NoSQL", value: "NoSQL" },
  { label: "HTML", value: "HTML" },
  { label: "CSS", value: "CSS" },
  { label: "React", value: "React" },
  { label: "Angular", value: "Angular" },
  { label: "Vue.js", value: "Vue.js" },
  { label: "Django", value: "Django" },
  { label: "Flask", value: "Flask" },
  { label: "Spring Boot", value: "Spring Boot" },
  { label: "Node.js", value: "Node.js" },
  { label: "Express.js", value: "Express.js" },
  { label: ".NET", value: ".NET" },
  { label: "Git", value: "Git" },
  { label: "Docker", value: "Docker" },
  { label: "Kubernetes", value: "Kubernetes" },
  { label: "AWS", value: "AWS" },
  { label: "Azure", value: "Azure" },
  { label: "Google Cloud Platform", value: "Google Cloud Platform" },
  { label: "Terraform", value: "Terraform" },
  { label: "Ansible", value: "Ansible" },
  { label: "Jenkins", value: "Jenkins" },
  { label: "CircleCI", value: "CircleCI" },
  { label: "Travis CI", value: "Travis CI" },
  { label: "Prometheus", value: "Prometheus" },
  { label: "Grafana", value: "Grafana" },
  { label: "Elasticsearch", value: "Elasticsearch" },
  { label: "Logstash", value: "Logstash" },
  { label: "Kibana", value: "Kibana" },
  { label: "Splunk", value: "Splunk" },
  { label: "Tableau", value: "Tableau" },
  { label: "Power BI", value: "Power BI" },
  { label: "Looker", value: "Looker" },
  { label: "Hadoop", value: "Hadoop" },
  { label: "Spark", value: "Spark" },
  { label: "Kafka", value: "Kafka" },
  { label: "RabbitMQ", value: "RabbitMQ" },
  { label: "TensorFlow", value: "TensorFlow" },
  { label: "PyTorch", value: "PyTorch" },
  { label: "Scikit-Learn", value: "Scikit-Learn" },
  { label: "Pandas", value: "Pandas" },
  { label: "NumPy", value: "NumPy" },
  { label: "R", value: "R" },
  { label: "MATLAB", value: "MATLAB" },
  { label: "Excel", value: "Excel" },
  { label: "Financial Modeling", value: "Financial Modeling" },
  { label: "Valuation", value: "Valuation" },
  { label: "Budgeting", value: "Budgeting" },
  { label: "Forecasting", value: "Forecasting" },
  { label: "Management Reporting", value: "Management Reporting" },
  { label: "Tax Compliance", value: "Tax Compliance" },
  { label: "GAAP", value: "GAAP" },
  { label: "IFRS", value: "IFRS" },
  { label: "Market Research", value: "Market Research" },
  { label: "Competitive Analysis", value: "Competitive Analysis" },
  { label: "Business Process Mapping", value: "Business Process Mapping" },
  { label: "BPMN", value: "BPMN" },
  { label: "Lean Six Sigma", value: "Lean Six Sigma" },
  { label: "Agile", value: "Agile" },
  { label: "Scrum", value: "Scrum" },
  { label: "Kanban", value: "Kanban" },
  { label: "PMP", value: "PMP" },
  { label: "PRINCE2", value: "PRINCE2" },
  { label: "UX Design", value: "UX Design" },
  { label: "UI Design", value: "UI Design" },
  { label: "Figma", value: "Figma" },
  { label: "Sketch", value: "Sketch" },
  { label: "Adobe Photoshop", value: "Adobe Photoshop" },
  { label: "Adobe Illustrator", value: "Adobe Illustrator" },
  { label: "InDesign", value: "InDesign" },
  { label: "Video Editing", value: "Video Editing" },
  { label: "Final Cut Pro", value: "Final Cut Pro" },
  { label: "Premiere Pro", value: "Premiere Pro" },
  { label: "Copywriting", value: "Copywriting" },
  { label: "Technical Writing", value: "Technical Writing" },
  { label: "Content Strategy", value: "Content Strategy" },
  { label: "SEO", value: "SEO" },
  { label: "SEM", value: "SEM" },
  { label: "Google Analytics", value: "Google Analytics" },
  { label: "Facebook Ads", value: "Facebook Ads" },
  { label: "LinkedIn Ads", value: "LinkedIn Ads" },
  { label: "CRM (Salesforce)", value: "CRM (Salesforce)" },
  { label: "HubSpot", value: "HubSpot" },
  { label: "Email Marketing", value: "Email Marketing" },
  { label: "Social Media Management", value: "Social Media Management" },
  { label: "Brand Management", value: "Brand Management" },
  { label: "Event Planning", value: "Event Planning" },
  { label: "Public Speaking", value: "Public Speaking" },
  { label: "Presentation Design", value: "Presentation Design" },
  { label: "Negotiation", value: "Negotiation" },
  { label: "Stakeholder Management", value: "Stakeholder Management" },
  { label: "Emotional Intelligence", value: "Emotional Intelligence" },
  { label: "Conflict Resolution", value: "Conflict Resolution" },
  { label: "Team Building", value: "Team Building" },
  { label: "Coaching", value: "Coaching" },
  { label: "Mentoring", value: "Mentoring" },
  { label: "Change Management", value: "Change Management" },
  { label: "Time Management", value: "Time Management" },
  { label: "Prioritization", value: "Prioritization" },
  { label: "Critical Thinking", value: "Critical Thinking" },
  { label: "Problem-Solving", value: "Problem-Solving" },
  { label: "Decision-Making", value: "Decision-Making" },
  { label: "Adaptability", value: "Adaptability" },
  { label: "Resilience", value: "Resilience" },
  { label: "Collaboration", value: "Collaboration" },
  { label: "Relationship Building", value: "Relationship Building" },
  { label: "Networking", value: "Networking" },
  { label: "Customer Service", value: "Customer Service" },
  { label: "Sales Techniques", value: "Sales Techniques" },
  { label: "Consultative Selling", value: "Consultative Selling" },
  { label: "Business Development", value: "Business Development" },
  { label: "Lead Generation", value: "Lead Generation" },
  { label: "Pipeline Management", value: "Pipeline Management" },
  { label: "Account Management", value: "Account Management" },
  { label: "Contract Negotiation", value: "Contract Negotiation" },
  { label: "Vendor Management", value: "Vendor Management" },
  { label: "Procurement", value: "Procurement" },
  { label: "Supply Chain Management", value: "Supply Chain Management" },
  { label: "Logistics Coordination", value: "Logistics Coordination" },
  { label: "Quality Assurance", value: "Quality Assurance" },
  { label: "Test Automation", value: "Test Automation" },
  { label: "Manual Testing", value: "Manual Testing" },
  { label: "Penetration Testing", value: "Penetration Testing" },
  { label: "Vulnerability Assessment", value: "Vulnerability Assessment" },
  {
    label: "Identity & Access Management",
    value: "Identity & Access Management",
  },
  { label: "Compliance (ISO 27001)", value: "Compliance (ISO 27001)" },
  { label: "GDPR", value: "GDPR" },
  { label: "HIPAA", value: "HIPAA" },
  { label: "Data Privacy", value: "Data Privacy" },
  { label: "Data Visualization", value: "Data Visualization" },
  { label: "Dashboarding", value: "Dashboarding" },
  { label: "Statistical Analysis", value: "Statistical Analysis" },
  { label: "A/B Testing", value: "A/B Testing" },
  { label: "Experiment Design", value: "Experiment Design" },
  { label: "CRM (Microsoft Dynamics)", value: "CRM (Microsoft Dynamics)" },
  { label: "ERP (SAP)", value: "ERP (SAP)" },
  { label: "RPA (UiPath)", value: "RPA (UiPath)" },
  { label: "Blockchain", value: "Blockchain" },
  { label: "Smart Contracts", value: "Smart Contracts" },
  { label: "Internet of Things (IoT)", value: "Internet of Things (IoT)" },
  { label: "Augmented Reality (AR)", value: "Augmented Reality (AR)" },
  { label: "Virtual Reality (VR)", value: "Virtual Reality (VR)" },
  { label: "Robotic Process Automation", value: "Robotic Process Automation" },
  { label: "ESG Analysis", value: "ESG Analysis" },
  { label: "Sustainability", value: "Sustainability" },
  { label: "Corporate Governance", value: "Corporate Governance" },
  { label: "Risk Management", value: "Risk Management" },
  { label: "Incident Response", value: "Incident Response" },
  { label: "Disaster Recovery", value: "Disaster Recovery" },
  { label: "Ethical Hacking", value: "Ethical Hacking" },
  { label: "UX Research", value: "UX Research" },
  { label: "User Testing", value: "User Testing" },
  { label: "Customer Journey Mapping", value: "Customer Journey Mapping" },
  { label: "Service Design", value: "Service Design" },
  { label: "Strategic Planning", value: "Strategic Planning" },
  { label: "Roadmapping", value: "Roadmapping" },
  { label: "Competitive Intelligence", value: "Competitive Intelligence" },
  { label: "Product Roadmap", value: "Product Roadmap" },
  {
    label: "Product Lifecycle Management",
    value: "Product Lifecycle Management",
  },
  {
    label: "Minimum Viable Product (MVP)",
    value: "Minimum Viable Product (MVP)",
  },
  { label: "Go-to-Market Strategy", value: "Go-to-Market Strategy" },
  { label: "Fundraising", value: "Fundraising" },
  { label: "Investor Relations", value: "Investor Relations" },
  { label: "Pitch Deck Creation", value: "Pitch Deck Creation" },
  { label: "Financial Due Diligence", value: "Financial Due Diligence" },
  { label: "Equity Analysis", value: "Equity Analysis" },
  { label: "Valuation Modeling", value: "Valuation Modeling" },
  { label: "Mergers & Acquisitions", value: "Mergers & Acquisitions" },
  { label: "Corporate Finance", value: "Corporate Finance" },
  { label: "Capital Markets", value: "Capital Markets" },
  { label: "Treasury Management", value: "Treasury Management" },
  { label: "Cash Flow Management", value: "Cash Flow Management" },
  { label: "Debt Financing", value: "Debt Financing" },
  { label: "Equity Financing", value: "Equity Financing" },
  { label: "ESG Reporting", value: "ESG Reporting" },
  { label: "Sustainability Reporting", value: "Sustainability Reporting" },
  { label: "Stakeholder Engagement", value: "Stakeholder Engagement" },
  { label: "Policy Analysis", value: "Policy Analysis" },
  { label: "Regulatory Compliance", value: "Regulatory Compliance" },
  { label: "Legislative Research", value: "Legislative Research" },
  {
    label: "Cross-Functional Leadership",
    value: "Cross-Functional Leadership",
  },
  {
    label: "Multicultural Team Management",
    value: "Multicultural Team Management",
  },
  { label: "Remote Team Management", value: "Remote Team Management" },
  { label: "Offshore Coordination", value: "Offshore Coordination" },
  { label: "Talent Acquisition", value: "Talent Acquisition" },
  { label: "Sourcing", value: "Sourcing" },
  { label: "Candidate Screening", value: "Candidate Screening" },
  { label: "Interviewing", value: "Interviewing" },
  { label: "Onboarding", value: "Onboarding" },
  { label: "Learning & Development", value: "Learning & Development" },
];

export const JOB_STATUS = [
  { label: "Open", value: 0 },
  { label: "Closed", value: 1 },
];

export const JOB_STATUS_FILTER = [
  { label: "Open", value: 0 },
  { label: "Closed", value: 1 },
  { label: "Expired", value: 2 },
  { label: "Draft", value: 3 },
];

export const RECOLATE = [
  { label: "Yes", value: 1 },
  { label: "No", value: 0 },
];

export const LANGUAGES = [
  { label: "English", value: "English" },
  { label: "Mandarin Chinese", value: "Mandarin Chinese" },
  { label: "Spanish", value: "Spanish" },
  { label: "Hindi", value: "Hindi" },
  { label: "Arabic", value: "Arabic" },
  { label: "Bengali", value: "Bengali" },
  { label: "Portuguese", value: "Portuguese" },
  { label: "Russian", value: "Russian" },
  { label: "Japanese", value: "Japanese" },
  { label: "Punjabi", value: "Punjabi" },
  { label: "German", value: "German" },
  { label: "Javanese", value: "Javanese" },
  { label: "Wu (Shanghainese)", value: "Wu (Shanghainese)" },
  { label: "Malay/Indonesian", value: "Malay/Indonesian" },
  { label: "Telugu", value: "Telugu" },
  { label: "Vietnamese", value: "Vietnamese" },
  { label: "Turkish", value: "Turkish" },
  { label: "Korean", value: "Korean" },
  { label: "French", value: "French" },
  { label: "Marathi", value: "Marathi" },
  { label: "Tamil", value: "Tamil" },
  { label: "Urdu", value: "Urdu" },
  { label: "Italian", value: "Italian" },
  { label: "Thai", value: "Thai" },
  { label: "Gujarati", value: "Gujarati" },
  { label: "Kannada", value: "Kannada" },
  { label: "Polish", value: "Polish" },
  { label: "Ukrainian", value: "Ukrainian" },
  { label: "Romanian", value: "Romanian" },
  { label: "Dutch", value: "Dutch" },
  { label: "Hungarian", value: "Hungarian" },
  { label: "Swahili", value: "Swahili" },
  { label: "Tagalog (Filipino)", value: "Tagalog (Filipino)" },
  { label: "Serbian", value: "Serbian" },
  { label: "Burmese", value: "Burmese" },
  { label: "Hausa", value: "Hausa" },
  { label: "Greek", value: "Greek" },
  { label: "Czech", value: "Czech" },
  { label: "Swedish", value: "Swedish" },
  { label: "Hebrew", value: "Hebrew" },
  { label: "Nepali", value: "Nepali" },
  { label: "Sinhala", value: "Sinhala" },
  { label: "Finnish", value: "Finnish" },
  { label: "Norwegian", value: "Norwegian" },
  { label: "Danish", value: "Danish" },
  { label: "Slovak", value: "Slovak" },
  { label: "Croatian", value: "Croatian" },
  { label: "Malayalam", value: "Malayalam" },
  { label: "Icelandic", value: "Icelandic" },
  { label: "Xhosa", value: "Xhosa" },
  { label: "Yoruba", value: "Yoruba" },
  { label: "Igbo", value: "Igbo" },
  { label: "Pidgin (Nigerian)", value: "Pidgin (Nigerian)" },
  { label: "Kanuri", value: "Kanuri" },
  { label: "Tiv", value: "Tiv" },
  { label: "Efik", value: "Efik" },
  { label: "Hausa", value: "Hausa" },
  { label: "Zulu", value: "Zulu" },
  { label: "Cantonese", value: "Cantonese" },
  { label: "Bengali", value: "Bengali" },
  { label: "Pashto", value: "Pashto" },
  { label: "Amharic", value: "Amharic" },
  { label: "Georgian", value: "Georgian" },
  { label: "Azerbaijani", value: "Azerbaijani" },
  { label: "Kurdish", value: "Kurdish" },
  { label: "Macedonian", value: "Macedonian" },
  { label: "Mongolian", value: "Mongolian" },
  { label: "Khmer", value: "Khmer" },
  { label: "Uzbek", value: "Uzbek" },
  { label: "Tajik", value: "Tajik" },
  { label: "Armenian", value: "Armenian" },
  { label: "Turkmen", value: "Turkmen" },
  { label: "Somali", value: "Somali" },
  { label: "Nepali", value: "Nepali" },
  { label: "Belarusian", value: "Belarusian" },
  { label: "Sinhalese", value: "Sinhalese" },
  { label: "Cebuano", value: "Cebuano" },
  { label: "Tigrinya", value: "Tigrinya" },
  { label: "Lao", value: "Lao" },
  { label: "Fijian", value: "Fijian" },
  { label: "Maltese", value: "Maltese" },
  { label: "Bislama", value: "Bislama" },
  { label: "Twi", value: "Twi" },
  { label: "Shona", value: "Shona" },
  { label: "Kinyarwanda", value: "Kinyarwanda" },
  { label: "Māori", value: "Māori" },
  { label: "Tatar", value: "Tatar" },
  { label: "Yiddish", value: "Yiddish" },
  { label: "Bosnian", value: "Bosnian" },
  { label: "Somali", value: "Somali" },
  { label: "Catalan", value: "Catalan" },
  { label: "Xhosa", value: "Xhosa" },
];

export const EMPLOYMENT_TYPES = [
  {
    label: "Contract",
    value: "contract",
  },
  {
    value: "full-time",
    label: "Full Time",
  },
  {
    value: "part-time",
    label: "Part Time",
  },
  {
    value: "internship",
    label: "Internship",
  },
  {
    value: "consultancy",
    label: "Consultancy",
  },
  {
    value: "freelance",
    label: "Freelance",
  },
];

export const GENDERS = [
  {
    label: "Male",
    value: "male",
  },
  {
    label: "Female",
    value: "female",
  },
];

export const COUNTRIES = [
  { label: "Afghanistan", name: "Afghanistan", value: "AF" },
  { label: "Albania", name: "Albania", value: "AL" },
  { label: "Algeria", name: "Algeria", value: "DZ" },
  { label: "Andorra", name: "Andorra", value: "AD" },
  { label: "Angola", name: "Angola", value: "AO" },
  { label: "Antigua and Barbuda", name: "Antigua and Barbuda", value: "AG" },
  { label: "Argentina", name: "Argentina", value: "AR" },
  { label: "Armenia", name: "Armenia", value: "AM" },
  { label: "Australia", name: "Australia", value: "AU" },
  { label: "Austria", name: "Austria", value: "AT" },
  { label: "Azerbaijan", name: "Azerbaijan", value: "AZ" },
  { label: "Bahamas", name: "Bahamas", value: "BS" },
  { label: "Bahrain", name: "Bahrain", value: "BH" },
  { label: "Bangladesh", name: "Bangladesh", value: "BD" },
  { label: "Barbados", name: "Barbados", value: "BB" },
  { label: "Belarus", name: "Belarus", value: "BY" },
  { label: "Belgium", name: "Belgium", value: "BE" },
  { label: "Belize", name: "Belize", value: "BZ" },
  { label: "Benin", name: "Benin", value: "BJ" },
  { label: "Bhutan", name: "Bhutan", value: "BT" },
  { label: "Bolivia", name: "Bolivia", value: "BO" },
  {
    label: "Bosnia and Herzegovina",
    name: "Bosnia and Herzegovina",
    value: "BA",
  },
  { label: "Botswana", name: "Botswana", value: "BW" },
  { label: "Brazil", name: "Brazil", value: "BR" },
  { label: "Brunei", name: "Brunei", value: "BN" },
  { label: "Bulgaria", name: "Bulgaria", value: "BG" },
  { label: "Burkina Faso", name: "Burkina Faso", value: "BF" },
  { label: "Burundi", name: "Burundi", value: "BI" },
  { label: "Cabo Verde", name: "Cabo Verde", value: "CV" },
  { label: "Cambodia", name: "Cambodia", value: "KH" },
  { label: "Cameroon", name: "Cameroon", value: "CM" },
  { label: "Canada", name: "Canada", value: "CA" },
  {
    label: "Central African Republic",
    name: "Central African Republic",
    value: "CF",
  },
  { label: "Chad", name: "Chad", value: "TD" },
  { label: "Chile", name: "Chile", value: "CL" },
  { label: "China", name: "China", value: "CN" },
  { label: "Colombia", name: "Colombia", value: "CO" },
  { label: "Comoros", name: "Comoros", value: "KM" },
  {
    label: "Congo, Democratic Republic of the",
    name: "Congo, Democratic Republic of the",
    value: "CD",
  },
  {
    label: "Congo, Republic of the",
    name: "Congo, Republic of the",
    value: "CG",
  },
  { label: "Costa Rica", name: "Costa Rica", value: "CR" },
  { label: "Croatia", name: "Croatia", value: "HR" },
  { label: "Cuba", name: "Cuba", value: "CU" },
  { label: "Cyprus", name: "Cyprus", value: "CY" },
  { label: "Czech Republic", name: "Czech Republic", value: "CZ" },
  { label: "Denmark", name: "Denmark", value: "DK" },
  { label: "Djibouti", name: "Djibouti", value: "DJ" },
  { label: "Dominica", name: "Dominica", value: "DM" },
  { label: "Dominican Republic", name: "Dominican Republic", value: "DO" },
  { label: "Ecuador", name: "Ecuador", value: "EC" },
  { label: "Egypt", name: "Egypt", value: "EG" },
  { label: "El Salvador", name: "El Salvador", value: "SV" },
  { label: "Equatorial Guinea", name: "Equatorial Guinea", value: "GQ" },
  { label: "Eritrea", name: "Eritrea", value: "ER" },
  { label: "Estonia", name: "Estonia", value: "EE" },
  { label: "Eswatini", name: "Eswatini", value: "SZ" },
  { label: "Ethiopia", name: "Ethiopia", value: "ET" },
  { label: "Fiji", name: "Fiji", value: "FJ" },
  { label: "Finland", name: "Finland", value: "FI" },
  { label: "France", name: "France", value: "FR" },
  { label: "Gabon", name: "Gabon", value: "GA" },
  { label: "Gambia", name: "Gambia", value: "GM" },
  { label: "Georgia", name: "Georgia", value: "GE" },
  { label: "Germany", name: "Germany", value: "DE" },
  { label: "Ghana", name: "Ghana", value: "GH" },
  { label: "Greece", name: "Greece", value: "GR" },
  { label: "Grenada", name: "Grenada", value: "GD" },
  { label: "Guatemala", name: "Guatemala", value: "GT" },
  { label: "Guinea", name: "Guinea", value: "GN" },
  { label: "Guinea-Bissau", name: "Guinea-Bissau", value: "GW" },
  { label: "Guyana", name: "Guyana", value: "GY" },
  { label: "Haiti", name: "Haiti", value: "HT" },
  { label: "Honduras", name: "Honduras", value: "HN" },
  { label: "Hungary", name: "Hungary", value: "HU" },
  { label: "Iceland", name: "Iceland", value: "IS" },
  { label: "India", name: "India", value: "IN" },
  { label: "Indonesia", name: "Indonesia", value: "ID" },
  { label: "Iran", name: "Iran", value: "IR" },
  { label: "Iraq", name: "Iraq", value: "IQ" },
  { label: "Ireland", name: "Ireland", value: "IE" },
  { label: "Israel", name: "Israel", value: "IL" },
  { label: "Italy", name: "Italy", value: "IT" },
  { label: "Jamaica", name: "Jamaica", value: "JM" },
  { label: "Japan", name: "Japan", value: "JP" },
  { label: "Jordan", name: "Jordan", value: "JO" },
  { label: "Kazakhstan", name: "Kazakhstan", value: "KZ" },
  { label: "Kenya", name: "Kenya", value: "KE" },
  { label: "Kiribati", name: "Kiribati", value: "KI" },
  { label: "Korea, North", name: "Korea, North", value: "KP" },
  { label: "Korea, South", name: "Korea, South", value: "KR" },
  { label: "Kuwait", name: "Kuwait", value: "KW" },
  { label: "Kyrgyzstan", name: "Kyrgyzstan", value: "KG" },
  { label: "Laos", name: "Laos", value: "LA" },
  { label: "Latvia", name: "Latvia", value: "LV" },
  { label: "Lebanon", name: "Lebanon", value: "LB" },
  { label: "Lesotho", name: "Lesotho", value: "LS" },
  { label: "Liberia", name: "Liberia", value: "LR" },
  { label: "Libya", name: "Libya", value: "LY" },
  { label: "Liechtenstein", name: "Liechtenstein", value: "LI" },
  { label: "Lithuania", name: "Lithuania", value: "LT" },
  { label: "Luxembourg", name: "Luxembourg", value: "LU" },
  { label: "Madagascar", name: "Madagascar", value: "MG" },
  { label: "Malawi", name: "Malawi", value: "MW" },
  { label: "Malaysia", name: "Malaysia", value: "MY" },
  { label: "Maldives", name: "Maldives", value: "MV" },
  { label: "Mali", name: "Mali", value: "ML" },
  { label: "Malta", name: "Malta", value: "MT" },
  { label: "Marshall Islands", name: "Marshall Islands", value: "MH" },
  { label: "Mauritania", name: "Mauritania", value: "MR" },
  { label: "Mauritius", name: "Mauritius", value: "MU" },
  { label: "Mexico", name: "Mexico", value: "MX" },
  { label: "Micronesia", name: "Micronesia", value: "FM" },
  { label: "Moldova", name: "Moldova", value: "MD" },
  { label: "Monaco", name: "Monaco", value: "MC" },
  { label: "Mongolia", name: "Mongolia", value: "MN" },
  { label: "Montenegro", name: "Montenegro", value: "ME" },
  { label: "Morocco", name: "Morocco", value: "MA" },
  { label: "Mozambique", name: "Mozambique", value: "MZ" },
  { label: "Myanmar", name: "Myanmar", value: "MM" },
  { label: "Namibia", name: "Namibia", value: "NA" },
  { label: "Nauru", name: "Nauru", value: "NR" },
  { label: "Nepal", name: "Nepal", value: "NP" },
  { label: "Netherlands", name: "Netherlands", value: "NL" },
  { label: "New Zealand", name: "New Zealand", value: "NZ" },
  { label: "Nicaragua", name: "Nicaragua", value: "NI" },
  { label: "Niger", name: "Niger", value: "NE" },
  { label: "Nigeria", name: "Nigeria", value: "NG" },
  { label: "North Macedonia", name: "North Macedonia", value: "MK" },
  { label: "Norway", name: "Norway", value: "NO" },
  { label: "Oman", name: "Oman", value: "OM" },
  { label: "Pakistan", name: "Pakistan", value: "PK" },
  { label: "Palau", name: "Palau", value: "PW" },
  { label: "Panama", name: "Panama", value: "PA" },
  { label: "Papua New Guinea", name: "Papua New Guinea", value: "PG" },
  { label: "Paraguay", name: "Paraguay", value: "PY" },
  { label: "Peru", name: "Peru", value: "PE" },
  { label: "Philippines", name: "Philippines", value: "PH" },
  { label: "Poland", name: "Poland", value: "PL" },
  { label: "Portugal", name: "Portugal", value: "PT" },
  { label: "Qatar", name: "Qatar", value: "QA" },
  { label: "Romania", name: "Romania", value: "RO" },
  { label: "Russia", name: "Russia", value: "RU" },
  { label: "Rwanda", name: "Rwanda", value: "RW" },
  {
    label: "Saint Kitts and Nevis",
    name: "Saint Kitts and Nevis",
    value: "KN",
  },
  { label: "Saint Lucia", name: "Saint Lucia", value: "LC" },
  {
    label: "Saint Vincent and the Grenadines",
    name: "Saint Vincent and the Grenadines",
    value: "VC",
  },
  { label: "Samoa", name: "Samoa", value: "WS" },
  { label: "San Marino", name: "San Marino", value: "SM" },
  {
    label: "Sao Tome and Principe",
    name: "Sao Tome and Principe",
    value: "ST",
  },
  { label: "Saudi Arabia", name: "Saudi Arabia", value: "SA" },
  { label: "Senegal", name: "Senegal", value: "SN" },
  { label: "Serbia", name: "Serbia", value: "RS" },
  { label: "Seychelles", name: "Seychelles", value: "SC" },
  { label: "Sierra Leone", name: "Sierra Leone", value: "SL" },
  { label: "Singapore", name: "Singapore", value: "SG" },
  { label: "Slovakia", name: "Slovakia", value: "SK" },
  { label: "Slovenia", name: "Slovenia", value: "SI" },
  { label: "Solomon Islands", name: "Solomon Islands", value: "SB" },
  { label: "Somalia", name: "Somalia", value: "SO" },
  { label: "South Africa", name: "South Africa", value: "ZA" },
  { label: "South Sudan", name: "South Sudan", value: "SS" },
  { label: "Spain", name: "Spain", value: "ES" },
  { label: "Sri Lanka", name: "Sri Lanka", value: "LK" },
  { label: "Sudan", name: "Sudan", value: "SD" },
  { label: "Suriname", name: "Suriname", value: "SR" },
  { label: "Sweden", name: "Sweden", value: "SE" },
  { label: "Switzerland", name: "Switzerland", value: "CH" },
  { label: "Syria", name: "Syria", value: "SY" },
  { label: "Taiwan", name: "Taiwan", value: "TW" },
  { label: "Tajikistan", name: "Tajikistan", value: "TJ" },
  { label: "Tanzania", name: "Tanzania", value: "TZ" },
  { label: "Thailand", name: "Thailand", value: "TH" },
  { label: "Timor-Leste", name: "Timor-Leste", value: "TL" },
  { label: "Togo", name: "Togo", value: "TG" },
  { label: "Tonga", name: "Tonga", value: "TO" },
  { label: "Trinidad and Tobago", name: "Trinidad and Tobago", value: "TT" },
  { label: "Tunisia", name: "Tunisia", value: "TN" },
  { label: "Turkey", name: "Turkey", value: "TR" },
  { label: "Turkmenistan", name: "Turkmenistan", value: "TM" },
  { label: "Tuvalu", name: "Tuvalu", value: "TV" },
  { label: "Uganda", name: "Uganda", value: "UG" },
  { label: "Ukraine", name: "Ukraine", value: "UA" },
  { label: "United Arab Emirates", name: "United Arab Emirates", value: "AE" },
  { label: "United Kingdom", name: "United Kingdom", value: "GB" },
  {
    label: "United States of America",
    name: "United States of America",
    value: "US",
  },
  { label: "Uruguay", name: "Uruguay", value: "UY" },
  { label: "Uzbekistan", name: "Uzbekistan", value: "UZ" },
  { label: "Vanuatu", name: "Vanuatu", value: "VU" },
  { label: "Vatican City", name: "Vatican City", value: "VA" },
  { label: "Venezuela", name: "Venezuela", value: "VE" },
  { label: "Vietnam", name: "Vietnam", value: "VN" },
  { label: "Yemen", name: "Yemen", value: "YE" },
  { label: "Zambia", name: "Zambia", value: "ZM" },
  { label: "Zimbabwe", name: "Zimbabwe", value: "ZW" },
];

export const STATES = [
  {
    name: "Abia",
    cities: [
      "Aba",
      "Abariba",
      "Arochukwu",
      "Bende",
      "Igbere",
      "Isuikwuato",
      "Nkporo",
      "Ohafia",
      "Osisioma",
      "Umuahia",
      "Uturu",
    ],
  },
  {
    name: "Adamawa",
    cities: [
      "Demsa",
      "Fufore",
      "Ganye",
      "Girei",
      "Gombi",
      "Guyuk",
      "Hong",
      "Jada",
      "Lamurde",
      "Madagali",
      "Maiha",
      "Mayo-Belwa",
      "Michika",
      "Mubi North",
      "Mubi South",
      "Numan",
      "Shelleng",
      "Song",
      "Toungo",
      "Yola North",
      "Yola South",
    ],
  },
  {
    name: "Akwa Ibom",
    cities: [
      "Abak",
      "Eastern Obolo",
      "Eket",
      "Esit Eket",
      "Essien Udim",
      "Etim Ekpo",
      "Etinan",
      "Ibeno",
      "Ibesikpo Asutan",
      "Ibiono-Ibom",
      "Ika",
      "Ikono",
      "Ikot Abasi",
      "Ikot Ekpene",
      "Ini",
      "Itu",
      "Mbo",
      "Mkpat-Enin",
      "Nsit-Atai",
      "Nsit-Ibom",
      "Nsit-Ubium",
      "Obot Akara",
      "Okobo",
      "Onna",
      "Oron",
      "Oruk Anam",
      "Udung-Uko",
      "Ukanafun",
      "Uruan",
      "Urue-Offong/Oruko",
      "Uyo",
    ],
  },
  {
    name: "Anambra",
    cities: [
      "Aguata",
      "Anambra East",
      "Anambra West",
      "Anaocha",
      "Awka North",
      "Awka South",
      "Ayamelum",
      "Dunukofia",
      "Ekwusigo",
      "Idemili North",
      "Idemili South",
      "Ihiala",
      "Njikoka",
      "Nnewi North",
      "Nnewi South",
      "Ogbaru",
      "Onitsha North",
      "Onitsha South",
      "Orumba North",
      "Orumba South",
      "Oyi",
    ],
  },
  {
    name: "Bauchi",
    cities: [
      "Alkaleri",
      "Bauchi",
      "Bogoro",
      "Damban",
      "Darazo",
      "Dass",
      "Gamawa",
      "Ganjuwa",
      "Giade",
      "Itas/Gadau",
      "Jama'are",
      "Katagum",
      "Kirfi",
      "Misau",
      "Ningi",
      "Shira",
      "Tafawa Balewa",
      "Toro",
      "Warji",
      "Zaki",
    ],
  },
  {
    name: "Bayelsa",
    cities: [
      "Brass",
      "Ekeremor",
      "Kolokuma/Opokuma",
      "Nembe",
      "Ogbia",
      "Sagbama",
      "Southern Ijaw",
      "Yenagoa",
    ],
  },
  {
    name: "Benue",
    cities: [
      "Ado",
      "Agatu",
      "Apa",
      "Buruku",
      "Gboko",
      "Guma",
      "Gwer East",
      "Gwer West",
      "Katsina-Ala",
      "Konshisha",
      "Kwande",
      "Logo",
      "Makurdi",
      "Obi",
      "Ogbadibo",
      "Oju",
      "Okpokwu",
      "Ohimini",
      "Oturkpo",
      "Tarka",
      "Ukum",
      "Ushongo",
      "Vandeikya",
    ],
  },
  {
    name: "Borno",
    cities: [
      "Abadam",
      "Askira/Uba",
      "Bama",
      "Bayo",
      "Biu",
      "Chibok",
      "Damboa",
      "Dikwa",
      "Gubio",
      "Guzamala",
      "Gwoza",
      "Hawul",
      "Jere",
      "Kaga",
      "Kala/Balge",
      "Konduga",
      "Kukawa",
      "Kwaya Kusar",
      "Mafa",
      "Magumeri",
      "Maiduguri",
      "Marte",
      "Mobbar",
      "Monguno",
      "Ngala",
      "Nganzai",
      "Shani",
    ],
  },
  {
    name: "Cross River",
    cities: [
      "Abi",
      "Akamkpa",
      "Akpabuyo",
      "Bekwarra",
      "Biase",
      "Boki",
      "Calabar Municipal",
      "Calabar South",
      "Etung",
      "Ikom",
      "Obanliku",
      "Obubra",
      "Obudu",
      "Odukpani",
      "Ogoja",
      "Yakuur",
      "Yala",
    ],
  },
  {
    name: "Delta",
    cities: [
      "Aniocha North",
      "Aniocha South",
      "Bomadi",
      "Burutu",
      "Ethiope East",
      "Ethiope West",
      "Ika North East",
      "Ika South",
      "Isoko North",
      "Isoko South",
      "Ndokwa East",
      "Ndokwa West",
      "Okpe",
      "Oshimili North",
      "Oshimili South",
      "Patani",
      "Sapele",
      "Udu",
      "Ughelli North",
      "Ughelli South",
      "Ukwuani",
      "Uvwie",
      "Warri North",
      "Warri South",
      "Warri South West",
    ],
  },
  {
    name: "Ebonyi",
    cities: [
      "Abakaliki",
      "Afikpo North",
      "Afikpo South",
      "Ebonyi",
      "Ezza North",
      "Ezza South",
      "Ikwo",
      "Ishielu",
      "Ivo",
      "Izzi",
      "Ohaozara",
      "Ohaukwu",
      "Onicha",
    ],
  },
  {
    name: "Edo",
    cities: [
      "Akoko-Edo",
      "Egor",
      "Esan Central",
      "Esan North-East",
      "Esan South-East",
      "Esan West",
      "Etsako Central",
      "Etsako East",
      "Etsako West",
      "Igueben",
      "Ikpoba-Okha",
      "Orhionmwon",
      "Oredo",
      "Ovia North-East",
      "Ovia South-West",
      "Owan East",
      "Owan West",
      "Uhunmwonde",
    ],
  },
  {
    name: "Ekiti",
    cities: [
      "Ado-Ekiti",
      "Efon",
      "Ekiti East",
      "Ekiti South-West",
      "Ekiti West",
      "Emure",
      "Gbonyin",
      "Ido-Osi",
      "Ijero",
      "Ikere",
      "Ikole",
      "Ilejemeje",
      "Irepodun/Ifelodun",
      "Ise/Orun",
      "Moba",
      "Oye",
    ],
  },
  {
    name: "Enugu",
    cities: [
      "Aninri",
      "Awgu",
      "Enugu East",
      "Enugu North",
      "Enugu South",
      "Ezeagu",
      "Igbo Etiti",
      "Igbo Eze North",
      "Igbo Eze South",
      "Isi Uzo",
      "Nkanu East",
      "Nkanu West",
      "Nsukka",
      "Oji River",
      "Udenu",
      "Udi",
      "Uzo-Uwani",
    ],
  },
  {
    name: "Gombe",
    cities: [
      "Akko",
      "Balanga",
      "Billiri",
      "Dukku",
      "Funakaye",
      "Gombe",
      "Kaltungo",
      "Kwami",
      "Nafada",
      "Shongom",
      "Yamaltu/Deba",
    ],
  },
  {
    name: "Imo",
    cities: [
      "Aboh Mbaise",
      "Ahiazu Mbaise",
      "Ehime Mbano",
      "Ezinihitte",
      "Ideato North",
      "Ideato South",
      "Ihitte/Uboma",
      "Ikeduru",
      "Isiala Mbano",
      "Isu",
      "Mbaitoli",
      "Ngor Okpala",
      "Njaba",
      "Nkwerre",
      "Nwangele",
      "Obowo",
      "Oguta",
      "Ohaji/Egbema",
      "Okigwe",
      "Orlu",
      "Orsu",
      "Oru East",
      "Oru West",
      "Owerri Municipal",
      "Owerri North",
      "Owerri West",
    ],
  },
  {
    name: "Jigawa",
    cities: [
      "Auyo",
      "Babura",
      "Biriniwa",
      "Birnin Kudu",
      "Buji",
      "Dutse",
      "Gagarawa",
      "Garki",
      "Gumel",
      "Guri",
      "Gwaram",
      "Gwiwa",
      "Hadejia",
      "Jahun",
      "Kafin Hausa",
      "Kaugama",
      "Kazaure",
      "Kiri Kasama",
      "Kiyawa",
      "Maigatari",
      "Malam Madori",
      "Miga",
      "Ringim",
      "Roni",
      "Sule Tankarkar",
      "Taura",
      "Yankwashi",
    ],
  },
  {
    name: "Kaduna",
    cities: [
      "Birnin Gwari",
      "Chikun",
      "Giwa",
      "Igabi",
      "Ikara",
      "Jaba",
      "Jema'a",
      "Kachia",
      "Kaduna North",
      "Kaduna South",
      "Kagarko",
      "Kajuru",
      "Kaura",
      "Kauru",
      "Kubau",
      "Kudan",
      "Lere",
      "Makarfi",
      "Sabon Gari",
      "Sanga",
      "Soba",
      "Zangon Kataf",
      "Zaria",
    ],
  },
  {
    name: "Kano",
    cities: [
      "Ajingi",
      "Albasu",
      "Bagwai",
      "Bebeji",
      "Bichi",
      "Bunkure",
      "Dala",
      "Dambatta",
      "Dawakin Kudu",
      "Dawakin Tofa",
      "Doguwa",
      "Fagge",
      "Gabasawa",
      "Garko",
      "Garun Mallam",
      "Gaya",
      "Gezawa",
      "Gwale",
      "Gwarzo",
      "Kabo",
      "Kano Municipal",
      "Karaye",
      "Kibiya",
      "Kiru",
      "Kumbotso",
      "Kunchi",
      "Kura",
      "Madobi",
      "Makoda",
      "Minjibir",
      "Nasarawa",
      "Rano",
      "Rimin Gado",
      "Rogo",
      "Shanono",
      "Sumaila",
      "Takai",
      "Tarauni",
      "Tofa",
      "Tsanyawa",
      "Tudun Wada",
      "Ungogo",
      "Warawa",
      "Wudil",
    ],
  },
  {
    name: "Katsina",
    cities: [
      "Bakori",
      "Batagarawa",
      "Batsari",
      "Baure",
      "Bindawa",
      "Charanchi",
      "Dandume",
      "Danja",
      "Dan Musa",
      "Daura",
      "Dutsi",
      "Dutsin Ma",
      "Faskari",
      "Funtua",
      "Ingawa",
      "Jibia",
      "Kafur",
      "Kaita",
      "Kankara",
      "Kankia",
      "Katsina",
      "Kurfi",
      "Kusada",
      "Mai'Adua",
      "Malumfashi",
      "Mani",
      "Mashi",
      "Matazu",
      "Musawa",
      "Rimi",
      "Sabuwa",
      "Safana",
      "Sandamu",
      "Zango",
    ],
  },
  {
    name: "Kebbi",
    cities: [
      "Aleiro",
      "Arewa Dandi",
      "Argungu",
      "Augie",
      "Bagudo",
      "Birnin Kebbi",
      "Bunza",
      "Dandi",
      "Fakai",
      "Gwandu",
      "Jega",
      "Kalgo",
      "Koko/Besse",
      "Maiyama",
      "Ngaski",
      "Sakaba",
      "Shanga",
      "Suru",
      "Danko-Wasagu",
      "Yauri",
      "Zuru",
    ],
  },
  {
    name: "Kogi",
    cities: [
      "Adavi",
      "Ajaokuta",
      "Ankpa",
      "Bassa",
      "Dekina",
      "Ibaji",
      "Idah",
      "Igalamela-Odolu",
      "Ijumu",
      "Kabba/Bunu",
      "Kogi",
      "Lokoja",
      "Mopa-Muro",
      "Ofu",
      "Ogori/Magongo",
      "Okehi",
      "Okene",
      "Olamaboro",
      "Omala",
      "Yagba East",
      "Yagba West",
    ],
  },
  {
    name: "Kwara",
    cities: [
      "Asa",
      "Baruten",
      "Edu",
      "Ekiti",
      "Ifelodun",
      "Ilorin East",
      "Ilorin South",
      "Ilorin West",
      "Irepodun",
      "Isin",
      "Kaiama",
      "Moro",
      "Offa",
      "Oke Ero",
      "Oyun",
      "Pategi",
    ],
  },
  {
    name: "Lagos",
    cities: [
      "Agege",
      "Ajeromi-Ifelodun",
      "Alimosho",
      "Amuwo-Odofin",
      "Apapa",
      "Badagry",
      "Epe",
      "Eti-Osa",
      "Ibeju-Lekki",
      "Ifako-Ijaiye",
      "Ikeja",
      "Ikorodu",
      "Kosofe",
      "Lagos Island",
      "Lagos Mainland",
      "Mushin",
      "Ojo",
      "Oshodi-Isolo",
      "Shomolu",
      "Surulere",
    ],
  },
  {
    name: "Nasarawa",
    cities: [
      "Akwanga",
      "Awe",
      "Doma",
      "Karu",
      "Keana",
      "Keffi",
      "Kokona",
      "Lafia",
      "Nasarawa",
      "Nasarawa Egon",
      "Obi",
      "Toto",
      "Wamba",
    ],
  },
  {
    name: "Niger",
    cities: [
      "Agaie",
      "Agwara",
      "Bida",
      "Borgu",
      "Bosso",
      "Chanchaga",
      "Edati",
      "Gbako",
      "Gurara",
      "Katcha",
      "Kontagora",
      "Lapai",
      "Lavun",
      "Magama",
      "Mariga",
      "Mashegu",
      "Mokwa",
      "Muya",
      "Paikoro",
      "Rafi",
      "Rijau",
      "Shiroro",
      "Suleja",
      "Tafa",
      "Wushishi",
    ],
  },
  {
    name: "Ogun",
    cities: [
      "Abeokuta North",
      "Abeokuta South",
      "Ado-Odo/Ota",
      "Ewekoro",
      "Ifo",
      "Ijebu East",
      "Ijebu North",
      "Ijebu North East",
      "Ijebu Ode",
      "Ikenne",
      "Imeko Afon",
      "Ipokia",
      "Obafemi Owode",
      "Odogbolu",
      "Ogun Waterside",
      "Remo North",
      "Shagamu",
      "Yewa North",
      "Yewa South",
    ],
  },
  {
    name: "Ondo",
    cities: [
      "Akoko North-East",
      "Akoko North-West",
      "Akoko South-East",
      "Akoko South-West",
      "Akure North",
      "Akure South",
      "Ese Odo",
      "Idanre",
      "Ifedore",
      "Ilaje",
      "Ile Oluji/Okeigbo",
      "Irele",
      "Odigbo",
      "Okitipupa",
      "Ondo East",
      "Ondo West",
      "Ose",
      "Owo",
    ],
  },
  {
    name: "Osun",
    cities: [
      "Atakunmosa East",
      "Atakunmosa West",
      "Aiyedaade",
      "Aiyedire",
      "Boluwaduro",
      "Boripe",
      "Ede North",
      "Ede South",
      "Ife Central",
      "Ife East",
      "Ife North",
      "Ife South",
      "Egbedore",
      "Ejigbo",
      "Ifedayo",
      "Ifelodun",
      "Ila",
      "Ilesa East",
      "Ilesa West",
      "Irepodun",
      "Irewole",
      "Isokan",
      "Iwo",
      "Obokun",
      "Odo Otin",
      "Ola Oluwa",
      "Olorunda",
      "Oriade",
      "Orolu",
      "Osogbo",
    ],
  },
  {
    name: "Oyo",
    cities: [
      "Afijio",
      "Akinyele",
      "Atiba",
      "Atisbo",
      "Egbeda",
      "Ibadan North",
      "Ibadan North-East",
      "Ibadan North-West",
      "Ibadan South-East",
      "Ibadan South-West",
      "Ibarapa Central",
      "Ibarapa East",
      "Ibarapa North",
      "Ido",
      "Irepo",
      "Iseyin",
      "Itesiwaju",
      "Iwajowa",
      "Kajola",
      "Lagelu",
      "Ogo Oluwa",
      "Ogbomosho North",
      "Ogbomosho South",
      "Olorunsogo",
      "Oluyole",
      "Ona Ara",
      "Orelope",
      "Ori Ire",
      "Oyo East",
      "Oyo West",
      "Saki East",
      "Saki West",
      "Surulere",
    ],
  },
  {
    name: "Plateau",
    cities: [
      "Barkin Ladi",
      "Bassa",
      "Bokkos",
      "Jos East",
      "Jos North",
      "Jos South",
      "Kanam",
      "Kanke",
      "Langtang North",
      "Langtang South",
      "Mangu",
      "Mikang",
      "Pankshin",
      "Qua'an Pan",
      "Riyom",
      "Shendam",
      "Wase",
    ],
  },
  {
    name: "Rivers",
    cities: [
      "Abua/Odual",
      "Ahoada East",
      "Ahoada West",
      "Akuku-Toru",
      "Andoni",
      "Asari-Toru",
      "Bonny",
      "Degema",
      "Emuoha",
      "Eleme",
      "Etche",
      "Gokana",
      "Ikwerre",
      "Khana",
      "Obio/Akpor",
      "Ogba/Egbema/Ndoni",
      "Ogu/Bolo",
      "Okrika",
      "Omuma",
      "Opobo/Nkoro",
      "Oyigbo",
      "Port Harcourt",
      "Tai",
    ],
  },
  {
    name: "Sokoto",
    cities: [
      "Binji",
      "Bodinga",
      "Dange Shuni",
      "Gada",
      "Goronyo",
      "Gudu",
      "Gwadabawa",
      "Illela",
      "Isa",
      "Kebbe",
      "Kware",
      "Rabah",
      "Sabon Birni",
      "Shagari",
      "Silame",
      "Sokoto North",
      "Sokoto South",
      "Tambuwal",
      "Tangaza",
      "Tureta",
      "Wamako",
      "Wurno",
      "Yabo",
    ],
  },
  {
    name: "Taraba",
    cities: [
      "Ardo Kola",
      "Bali",
      "Donga",
      "Gashaka",
      "Gassol",
      "Ibi",
      "Jalingo",
      "Karim Lamido",
      "Kurmi",
      "Lau",
      "Sardauna",
      "Takum",
      "Ussa",
      "Wukari",
      "Yorro",
      "Zing",
    ],
  },
  {
    name: "Yobe",
    cities: [
      "Bade",
      "Bursari",
      "Damaturu",
      "Fika",
      "Fune",
      "Geidam",
      "Gujba",
      "Gulani",
      "Jakusko",
      "Karasuwa",
      "Machina",
      "Nangere",
      "Nguru",
      "Potiskum",
      "Tarmuwa",
      "Yunusari",
      "Yusufari",
    ],
  },
  {
    name: "Zamfara",
    cities: [
      "Anka",
      "Bakura",
      "Birnin Magaji/Kiyaw",
      "Bukkuyum",
      "Bungudu",
      "Gummi",
      "Gusau",
      "Kaura Namoda",
      "Maradun",
      "Maru",
      "Shinkafi",
      "Talata Mafara",
      "Chafe",
      "Zurmi",
    ],
  },
  {
    name: "Federal Capital Territory",
    cities: [
      "Abaji",
      "Bwari",
      "Gwagwalada",
      "Kuje",
      "Kwali",
      "Municipal Area Council",
    ],
  },
];

export const JOB_POSTED_OPTIONS = [
  { label: "Last 24 hours", value: "1" },
  { label: "Last 7 days", value: "7" },
  { label: "Last 14 days", value: "14" },
  { label: "Last 30 days", value: "30" },
];

export const DEFAULT_OG_IMAGE = "https://arno.jobs/default-og-image.jpg";